import { Row, Col, Input, Button, Modal, Checkbox, Upload, Table, Image, Form, Tag, Popover, Select, notification } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import { fetchData, sendData, sendDataPut } from '../../httpRequests';
const { Search } = Input;

const form = {
    id: null,
    name: '',
    price: null,
    description: "",
    days:0

}
const editAds = (
    <small>
        Edit
    </small>
);
const deleteAds = (
    <small>
        Delete
    </small>
);

const activeAds = (
    <div>
        <small>Si desactiva este plan no estara disponible para mostrarse los anuncios relacionados.</small>
    </div>
);

export default function plans() {
    const [isModalVisibleCreatePlan, setIsModalVisibleCreatePlan] = useState(false);
    const [formValues, setFormValues] = useState(form)
    const [plans, setPlans] = useState([])
    const [plansName, setPlansName] = useState([])
    const [tbLoading, setTbLoading] = useState(false)
    const [modo, setModo] = useState(false)
    const [amount, setAmount] = useState(0)


    const { id, price, name, description, days } = formValues
    useEffect(() => {
        getPlans()
    }, [])

    const handleInputChange = ({ target }) => {
        setFormValues({
            ...formValues,
            [target.name]: target.value
        });
    }

    const savePlan = () => {
        setTbLoading(true)
        const data = {
            description,
            price,
            name,
            days
        };
        if (modo == false) {
            const url = '/plans/createPlans';
            sendData(url, data).then((response) => {
                if (response.ok) {
                    openNotificationWithIcon("success", response.msg)
                    setIsModalVisibleCreatePlan(false)
                    getPlans()
                    clearForm()
                } else {
                    openNotificationWithIcon("warning", "error")
                }
            })
        } else {
            const url = `/plans/putPlans/${id}`;
            sendDataPut(url, data).then((response) => {
                if (response.ok) {
                    openNotificationWithIcon("success", response.msg)
                    setIsModalVisibleCreatePlan(false)
                    getPlans()
                    clearForm()
                } else {
                    openNotificationWithIcon("warning", "error")
                }
            })
        }
        setTbLoading(false)


    }

    const getPlans = () => {
        setTbLoading(true)
        const url = '/plans/getPlans';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const plans = response['plans'];
                setPlans(plans)
                setPlansName(plans)
            }
        })
        setTbLoading(false)
    }
    // edit
    const showModalEditar = (id, price, description, name) => {
        setModo(true)
        setIsModalVisibleCreatePlan(true)
        const data = {
            id,
            price,
            description,
            name
        }
        setFormValues(data)
    }

    // clear form
    const clearForm = () => {
        const data = {
            id: null,
            name: '',
            price: null,
            description: ""
        }
        setFormValues(data)
    }

    const onSearch = (value) => {
        let text = value.target.value.trim()

        if (text) {
            let newText = String(text)
            const filteredPlansName = plans.filter((n) => {
                return n.name.toLowerCase().trim().includes(text.toLowerCase())
            });
            setPlansName(filteredPlansName);
        } else {
            setPlansName(plans);
        }
    }

    const columns = [
        {
            title: 'NAME',
            dataIndex: 'name',
            key: 'name',
        },
        
        {
            title: 'DESCRIPTION',
            render: ({ id, status, img, description }) => (
                <div style={{ maxWidth: '500px' }}>
                    {description}
                </div>
            )
        },
        {
            title: 'DAYS',
            dataIndex: 'days',
            key: 'days',
        },
        {
            title: 'PRICE',
            render: ({ id, status, img, description, price }) => (
                <div style={{ maxWidth: '500px' }}>
                    <b style={{ color: 'green' }}>$</b>{price}
                </div>
            )
        },
        {
            title: 'STATUS',
            render: ({ id, status, img }) => (
                <div style={{ cursor: 'pointer' }}>
                    {
                        (status == true)
                            ? <Popover content={activeAds} trigger="hover">
                                <Tag color="green">Active</Tag>
                            </Popover>
                            : <Tag color="volcano">Disabled</Tag>
                    }
                </div>
            )
        },
        {
            title: 'ACTION',
            render: ({ id, price, description, name }) => (
                <div style={{ display: 'flex' }} onClick={() => showModalEditar(id, price, description, name)}>
                    <Popover content={editAds} trigger="hover">
                        <span style={{ margin: 10, cursor: 'pointer' }}>
                            <EditOutlined style={{ fontSize: '25px', color: '#128780' }} />
                        </span>
                    </Popover>

                    <Popover content={deleteAds} trigger="hover">
                        <span style={{ margin: 10, cursor: 'pointer' }}  >
                            <DeleteOutlined style={{ fontSize: '25px', color: 'red' }} />
                        </span>
                    </Popover>
                </div>
            )
        }

    ];

    const showModalCreatePlan = () => {
        setModo(false)
        setIsModalVisibleCreatePlan(true)
    }
    const handleCancel = () => {
        setIsModalVisibleCreatePlan(false)
    }
    // notificaiones o errores
    const openNotificationWithIcon = (type, mensaje) => {
        notification[type]({
            description: mensaje
        });
    };
    const verCantidad = (e) => {
        console.log(e.target.value.length)
        setAmount(e.target.value.trim().length)
    }
    return (
        <div>

            <Row gutter={24} style={{ marginBottom: '20px' }}>
                <Col span={16}>
                    <Search
                        size='large'
                        placeholder='Search name'
                        onChange={onSearch}
                    />
                </Col>
                <Col span={8}>
                    <Button
                        onClick={showModalCreatePlan}
                        type='primary'
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                    >
                        {/* <PlusOutlined /> */}
                        Create plan
                    </Button>
                </Col>

            </Row>
            <Modal title={modo ? "Edit Plan" : "Add Plans"}
                visible={isModalVisibleCreatePlan}
                onCancel={handleCancel}
                width={600}
                footer={null}
                closable={true}
            >
                <Row gutter={24}>

                    <Col span={24} >
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>NAME</label>
                        <Input
                            type='text'
                            required
                            size='large'
                            name="name"
                            value={name}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={24} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>PRICE</label>
                        <Input
                            type='number'
                            size='large'
                            name="price"
                            value={price}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={24} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Days</label>
                        <Input
                            type='number'
                            size='large'
                            name="days"
                            value={days}
                            onChange={handleInputChange}
                        />
                    </Col>
                    <Col span={24} className='formMarginInput'>
                        <label style={{ marginTop: '100px' }}><span style={{ color: 'red', marginTop: '100px' }}>*</span>DESCRIPTION</label>
                        <Input.TextArea
                            name="description"
                            value={description}
                            onChange={handleInputChange} style={{ height: '100px' }}
                            onKeyUp={verCantidad} />
                        <div style={{ display: 'flex' }}>
                        <small>Cantidad Entre 100 y 200 caracteres </small>
                            <small style={{ textAlign: 'right' }}>
                            {(amount > 200 || amount < 100) ? <b style={{ color: 'red' }}>{amount}</b> : <b style={{ color: 'green' }}>{amount}</b>}<b>/200</b></small>
                            </div>
                            

                    </Col>

                    <Col span={24} style={{ marginTop: '10px' }}>
                        <Button
                            htmlType="submit"
                            onClick={savePlan}
                            type='primary'
                            size='large'
                            style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                            disabled={name == null || name == '' || price == '' || price == null || description == '' || description == null || amount > 200 || amount < 100 || days <= 0}

                        >
                            <SaveOutlined />
                            Save
                        </Button>
                    </Col>


                </Row>
            </Modal>
            <Table columns={columns} dataSource={plansName} rowKey={(item) => item.id}
                loading={tbLoading} />
        </div>
    )

}